const CREATE_COMPETITIONS_FEATURE = [
  {
    src: new URL(
      '~/public/assets/images/Landing/createCompetitionsFeature.png?as=avif',
      import.meta.url
    ).href,
    alt: 'Landing',
    as: 'image/avif'
  },
  {
    src: new URL(
      '~/public/assets/images/Landing/createCompetitionsFeature.png?as=webp',
      import.meta.url
    ).href,
    alt: 'Landing',
    as: 'image/webp'
  },
  {
    src: new URL(
      '~/public/assets/images/Landing/createCompetitionsFeature.png',
      import.meta.url
    ).href,
    alt: 'Landing',
    as: 'image/png'
  }
]

export default CREATE_COMPETITIONS_FEATURE
